export default __webpack_public_path__ + "static/media/automation-home-small.bed99489.jpg";